import React from "react"
import BgImage from "./bgstyle"
import SrcSetImage from "./srcset"
import PictureSrc from "./pic-src";

const ShowProcessedImage = props => {
  if (props.renderer === "bgImg") {
    return <BgImage props={props} />
  } else if (props.renderer === "pic-src") {
    return <PictureSrc props={props} />
  }
  return <SrcSetImage props={props} />
}

export { ShowProcessedImage }